document.addEventListener("DOMContentLoaded", function () {
  var products_collection_new = new Swiper(
    ".related-products .related-products-container",
    {
      slidesPerView: 1.3,
      loop: false,
      // slidesPerGroup: 4,
      spaceBetween: 24,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".related-products .swiper-button-next",
        prevEl: ".related-products .swiper-button-prev",
      },
      pagination: {
        el: ".related-products .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        590: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    }
  );

  $(".related-products .color-list .color-btn").click(function () {
    var variantId = $(this).data("variant");
    var productId = $(this).data("id");
    var img = $(this).data("img");
    $(
      '.product-item[data-id="' + productId + '"] .color-list .color-btn.active'
    ).removeClass("active");
    $(this).addClass("active");
    $('.product-item[data-id="' + productId + '"] .product-item-img img').attr(
      "src",
      img
    );
  });
});
